import { render } from "./ContentDate.vue?vue&type=template&id=df065530"
import script from "./ContentDate.vue?vue&type=script&lang=js"
export * from "./ContentDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__